import React, { Component, createRef } from "react";
import { FormattedMessage } from "react-intl";
import { Pagination, Select } from "antd";
import { NextIcon, PagerJumpIcon, PrevIcon } from "../../../../common/icons";
import HUBContext from "../../../../services/HUBContext";
import { withStyles } from "@material-ui/core";
import { styles } from "./CustomPaginatorWidget.styles";
import {
  defaultPageSize,
  defaultPageSizeOptions,
  translations,
} from "./constants";

const { Option } = Select;

class CustomPaginatorWidget extends Component {
  state = {
    width: 0,
    isSizeChangerOpen: false,
  };

  constructor(props) {
    super(props);
    this.componentRef = createRef();
  }

  componentDidMount() {
    this.resizeObserver = new ResizeObserver((e) => {
      for (let entry of e) {
        this.setState({ width: entry.contentRect.width });
      }
    });

    if (this.componentRef.current) {
      this.resizeObserver.observe(this.componentRef.current);
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver && this.componentRef.current) {
      this.resizeObserver.unobserve(this.componentRef.current);
    }
  }

  paginationItemRender = (_, type, originalElement) => {
    const icons = {
      "jump-prev": <PagerJumpIcon />,
      "jump-next": <PagerJumpIcon />,
      prev: <PrevIcon />,
      next: <NextIcon />,
    };
    return icons[type] || originalElement;
  };

  renderPageInfo = (pageIndex, pageSize, total) => {
    const start = total ? pageIndex * pageSize + 1 : 0;
    const end = Math.min((pageIndex + 1) * pageSize, total);

    return (
      <FormattedMessage
        id={translations.pagerInfo.id}
        defaultMessage={translations.pagerInfo.defaultMessage}
        values={[start, end, total]}
      />
    );
  };

  render() {
    const {
      pagerInfo,
      pageSizeOptions,
      onChange,
      onShowSizeChange,
      options,
      leftOptions,
      showLessItems,
      classes,
    } = this.props;
    const { width, isSizeChangerOpen } = this.state;

    const currentSize = String(pagerInfo?.pageSize || defaultPageSize);
    const optionsList = pageSizeOptions || defaultPageSizeOptions;
    const isSmallScreen = width < (!!showLessItems ? 700 : 840);

    const paginationProps = {
      current: (pagerInfo?.pageIndex || 0) + 1,
      pageSize: pagerInfo?.pageSize || 5,
      total: pagerInfo?.count || 0,
      onChange: (current) => {
        if (typeof onChange === "function") onChange(current);
      },
      ...options,
    };

    const pageIndex = pagerInfo?.pageIndex ?? 0;
    const pageSize = pagerInfo?.pageSize ?? defaultPageSize;
    const total = pagerInfo?.count ?? 0;

    return (
      <div
        className={classes.pagination}
        ref={this.componentRef}
        style={{
          justifyContent: isSmallScreen ? "center" : "space-between",
        }}
      >
        <div
          className={`${classes.paginationSection} ${classes.paginationLeft}`}
          style={{
            display: isSmallScreen ? "none" : "flex",
            alignItems: "center",
          }}
        >
          <span>
            <FormattedMessage
              id={translations.showInfo.id}
              defaultMessage={translations.showInfo.defaultMessage}
            />
            :
          </span>

          <Select
            value={currentSize}
            open={isSizeChangerOpen}
            dropdownClassName={classes.pageSizeDropdown}
            onDropdownVisibleChange={(open) =>
              this.setState({ isSizeChangerOpen: open })
            }
            onChange={(value) => {
              const newSize = Number(value);
              this.setState({ isSizeChangerOpen: false });
              if (typeof onShowSizeChange === "function") {
                onShowSizeChange((pagerInfo?.pageIndex || 0) + 1, newSize);
              }
            }}
            style={{ width: "60px" }}
          >
            {optionsList.map((size) => (
              <Option key={size} value={size}>
                <span>{size}</span>
              </Option>
            ))}
          </Select>

          <Pagination
            showSizeChanger={false}
            {...paginationProps}
            {...(leftOptions || {})}
          />

          <span className={classes.pagerInfo}>
            {this.renderPageInfo(pageIndex, pageSize, total)}
          </span>
        </div>

        <div
          className={`${classes.paginationSection} ${classes.paginationRight}`}
        >
          <Pagination
            showLessItems={!!showLessItems}
            showSizeChanger={false}
            itemRender={this.paginationItemRender}
            {...paginationProps}
          />
        </div>
      </div>
    );
  }
}

CustomPaginatorWidget.contextType = HUBContext;
export default withStyles(styles)(CustomPaginatorWidget);
